import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQuantopianComponent } from './simple-icons-quantopian.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQuantopianComponent ],
    exports:      [ SimpleIconsQuantopianComponent ],
    bootstrap:    []
})
export class SimpleIconsQuantopianModule {}
